var map = {
	"./": 469,
	"./development": 1411,
	"./development.js": 1411,
	"./index": 469,
	"./index.js": 469,
	"./preprod": 1412,
	"./preprod.js": 1412,
	"./production": 1391,
	"./production.js": 1391,
	"./staging": 1413,
	"./staging.js": 1413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3440;